import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllTermsOfUseQueryVariables = Types.Exact<{
  organisationUuid: Types.Scalars['String']['input'];
}>;


export type GetAllTermsOfUseQuery = { __typename?: 'Query', organisation: { __typename?: 'Organisation', id: string, allTermsOfUse: Array<{ __typename?: 'TermsOfUse', id: string, uuid: string, updatedAt: number, text: string, membersAccepted: Array<{ __typename?: 'OrganisationMemberUser', id: string, user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> }> } };

export type UserBasicInfoFragment = { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null };

export const UserBasicInfoFragmentDoc = gql`
    fragment UserBasicInfo on User {
  id
  uuid
  email
  username
  photoUrl
  firstName
  lastName
}
    `;
export const GetAllTermsOfUseDocument = gql`
    query GetAllTermsOfUse($organisationUuid: String!) {
  organisation(uuid: $organisationUuid) {
    id
    allTermsOfUse {
      id
      uuid
      updatedAt
      text
      membersAccepted {
        id
        user {
          ...UserBasicInfo
        }
      }
    }
  }
}
    ${UserBasicInfoFragmentDoc}`;

/**
 * __useGetAllTermsOfUseQuery__
 *
 * To run a query within a React component, call `useGetAllTermsOfUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTermsOfUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTermsOfUseQuery({
 *   variables: {
 *      organisationUuid: // value for 'organisationUuid'
 *   },
 * });
 */
export function useGetAllTermsOfUseQuery(baseOptions: Apollo.QueryHookOptions<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables> & ({ variables: GetAllTermsOfUseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables>(GetAllTermsOfUseDocument, options);
      }
export function useGetAllTermsOfUseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables>(GetAllTermsOfUseDocument, options);
        }
// @ts-ignore
export function useGetAllTermsOfUseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables>;
export function useGetAllTermsOfUseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTermsOfUseQuery | undefined, GetAllTermsOfUseQueryVariables>;
export function useGetAllTermsOfUseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables>(GetAllTermsOfUseDocument, options);
        }
export type GetAllTermsOfUseQueryHookResult = ReturnType<typeof useGetAllTermsOfUseQuery>;
export type GetAllTermsOfUseLazyQueryHookResult = ReturnType<typeof useGetAllTermsOfUseLazyQuery>;
export type GetAllTermsOfUseSuspenseQueryHookResult = ReturnType<typeof useGetAllTermsOfUseSuspenseQuery>;
export type GetAllTermsOfUseQueryResult = Apollo.QueryResult<GetAllTermsOfUseQuery, GetAllTermsOfUseQueryVariables>;